/**
 * Formats a number with comma as thousands separator.
 *
 * @param value - Number to format (integer or float)
 * @returns Formatted string, e.g. 12642 -> "12,642", 12642.5 -> "12,642.5"
 *
 * @example
 * formatNumberWithCommas(12642)   // "12,642"
 * formatNumberWithCommas(1000000) // "1,000,000"
 * formatNumberWithCommas(12642.5) // "12,642.5"
 */
export function formatNumberWithCommas(value: number): string {
  return value.toLocaleString("en-US", { maximumFractionDigits: 20 });
}
